import React from 'react';

import { TableHead, TableRow } from 'components/table';
import { t } from 'utils/language';

import './campaigns-table-influencer-head.scss';

const CampaignsTableInfluencerHead = () => (
  <TableRow nowrap className="campaigns-table-influencer-head">
    <TableHead width="tiny">
      {t('campaigns_column_brand')}
    </TableHead>

    <TableHead width="bigger">
      {t('campaigns_column_campaign')}
    </TableHead>

    <TableHead width="232px">
      {t('campaigns_column_date')}
    </TableHead>

    <TableHead width="270px">
      {t('campaigns_column_budget')}
    </TableHead>

    <TableHead width="fill" align="left">
      <div className="campaigns-table-influencer-head__action">
        {t('campaigns_column_actions')}
      </div>
    </TableHead>
  </TableRow>
);

export default CampaignsTableInfluencerHead;
